export default {"src":"/_next/static/media/Discord_Icon.4a5300c9.svg","height":75,"width":79,"blurWidth":0,"blurHeight":0};